export const productDetailFrames = new Map<string, string>([
	['/shop/prescription-glasses', `
		From $75 with prescription lenses (or 2 pairs from $120), Dresden frames are manufactured using 100% recyclable or recycled materials, with low CO2 emissions. Made in Australia means high quality, with ethical production standards guaranteed. Reject fast fashion with one universal, customisable design and modular spare parts. Dresden frames come with a 10 year warranty, no questions asked. You break them, we’ll replace them.
	`],
	['/shop/prescription-sunglasses', `
		From $100 with prescription UV tint lenses (or 2 from $160). Choose between a range of lens treatment options including polarisation, photochromic or mirror. Dresden frames are manufactured using 100% recyclable or recycled materials, with less CO2 emissions. Made in Australia means high quality, with ethical production standards guaranteed. Reject fast fashion with one universal, customisable design and modular spare parts. Frames that are built to last with a 10 year warranty.
	`],
	['/shop/blue-light-filter-glasses', `
		In the increasingly digital world, sleep better and improve your general wellbeing with lenses designed to reduce digital eye strain while using screens by filtering out artificial blue light. Dresden frames are manufactured using 100% recyclable or recycled materials, with less CO2 emissions. Made in Australia means high quality, with ethical production standards guaranteed. Reject fast fashion with one universal, customisable design and modular spare parts. Frames that are built to last with a 10 year warranty.
	`],
	['/shop/non-prescription-glasses', `
		Salute the sun and protect your eyes from harmful UVA and UVB rays with high quality sunnies. Dresden frames are manufactured using 100% recyclable or recycled materials, with less CO2 emissions. Made in Australia means high quality, with ethical production standards guaranteed. Reject fast fashion with one universal, customisable design and modular spare parts. Frames that are built to last with a 10 year warranty.
	`]
]);

export const productDetailLenses = new Map<string, string>([
	['/shop/prescription-glasses', `
		Enter your prescription to choose from a wide range of high quality lenses to suit your visual needs. We’ll automatically supply lens options such as thinning and coatings based on your prescription and frame size details. All Dresden lenses come with anti-reflective, anti-scratch coating as standard.
	`],
	['/shop/prescription-sunglasses', `
		Enter your prescription to choose between a range of category 3 lenses with UV tint, polarised UV tint, mirrored UV tint or photochromatic. All Dresden tinted sunglass lenses come with anti-reflective, anti-scratch coating as standard.
	`],
	['/shop/blue-light-filter-glasses', `
		Blue light lenses filter out the the artificial blue light that is emitted by LED screens like computers, laptops, televisions and smartphones. These lenses also come with anti-reflective and anti-scratch coating as standard.
	`],
	['/shop/non-prescription-glasses', `
		Choose between a range of category 3 lenses in UV tint, polarised UV tint or mirrored UV tint with no extra charge. All Dresden tinted sunglass lenses come with anti-reflective, anti-scratch coating as standard.
	`]
]);



export const prescriptionShippingAndReturnContent: any = {
	au: {
		prescription: {
			title: 'Prescription',
			description: 'A valid prescription within the past 24 months is required for the supply of glasses. Don’t have a valid prescription? <a href="/au/book-an-optometrist" style="color:#00aec7">Book an appointment</a> with us or call us at (02) 5300 3003.',
		},
		shipping: {
			title: 'Shipping',
			description: `It usually takes 1-3 weeks to deliver the prescription glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@dresden.vision or (02) 5300 3003.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.

</br>
</br>

<span class="font-medium">30-Day Satisfaction Guarantee</span> </br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
</br>
	</br>
<span class="font-medium">How to Initiate a Return or Exchange</span> <br>
Contact our customer support team at hello@dresden.vision or call (02) 5300 3003 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you'll receive instructions on how to return the item.</br>
</br>
<span class="font-medium">Return Shipping</span> <br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
</br>
	</br>
<span class="font-medium">Refunds</span> <br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
</br>
	</br>
<span class="font-medium">Exchanges</span> <br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
</br>
	</br>
<span class="font-medium">Damaged or Defective Items</span> <br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
</br>
	</br>
<span class="font-medium">Contact Us</span> <br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@dresden.vision or call <br> (02) 5300 3003.`,
		},
	},
	nz: {
		prescription: {
			title: 'Prescription',
			description: 'A valid prescription within the past 24 months is required for the supply of glasses.',
		},
		shipping: {
			title: 'Shipping',
			description: `It usually takes 1-3 weeks to deliver the prescription glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@dresden.vision or 0800 447 111.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
Contact our customer support team at hello@dresden.vision or call 0800 447 111 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you'll receive instructions on how to return the item.</br>
	</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@dresden.vision or call 0800 447 111.`,
		},
	},
	ca: {
		prescription: {
			title: 'Prescription',
			description: 'A valid prescription within the past 24 months is required for the supply of glasses. Don’t have a valid prescription? <a href="/ca/book-an-eye-exam" style="color:#00aec7">Book an appointment</a> with us or call us at (647) 424 4288.',
		},
		shipping: {
			title: 'Shipping',
			description: `It usually takes 10-17 days to deliver the prescription glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@ca.dresden.vision or (647) 424 4288.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are dedicated to ensuring your satisfaction with every purchase. If you're not completely satisfied with your glasses, we offer a simple returns policy to provide you with peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We stand behind the quality of our products. If you’re not fully satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please ensure the item is returned in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
Contact our customer support team at hello@ca.dresden.vision or call (647) 424 4288 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you will receive instructions on how to return the item.</br>
	</br>
</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days of receiving the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you wish to exchange your item for a different colour, style, or size, please specify your preference when initiating the return process. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, please contact us immediately. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For further assistance or questions regarding returns, please contact our customer support team at hello@ca.dresden.vision or call (647) 424 4288.`,
		},
	},
	international: {
		prescription: {
			title: 'Prescription',
			description: 'A valid prescription within the past 24 months is required for the supply of glasses.',
		},
		shipping: {
			title: 'Shipping',
			description: `It usually takes 2-3 weeks to deliver the prescription glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@int.dresden.vision or +1 (213) 223-6100.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order. <br><br>Please be advised that the destination country may apply import taxes, customs duties, or other fees. These charges will be handled by the customer/recipient. Dresden is not responsible for VAT or Import Taxes on shipments. The customer/recipient will handle any customs duties and extra fees from the destination country.
`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
Contact our customer support team at hello@int.dresden.vision or call +1 (213) 223-6100 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you'll receive instructions on how to return the item.</br>
</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@int.dresden.vision or call +1 (213) 223-6100.`,
		},
	},
};


export const nonPrescriptionShippingAndReturnContent: any = {
	au: {
		shipping: {
			title: 'Shipping',
			description: `It usually takes 1-3 weeks to deliver the glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@dresden.vision or (02) 5300 3003.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.

</br>
</br>

<span class="font-medium">30-Day Satisfaction Guarantee</span> </br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
</br>
	</br>
<span class="font-medium">How to Initiate a Return or Exchange</span> <br>
Contact our customer support team at hello@dresden.vision or call (02) 5300 3003 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you'll receive instructions on how to return the item.</br>
	</br>
<span class="font-medium">Return Shipping</span> <br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
</br>
	</br>
<span class="font-medium">Refunds</span> <br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
</br>
	</br>
<span class="font-medium">Exchanges</span> <br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
</br>
	</br>
<span class="font-medium">Damaged or Defective Items</span> <br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
</br>
	</br>
<span class="font-medium">Contact Us</span> <br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@dresden.vision or call <br> (02) 5300 3003.`,
		},
	},
	nz: {
		shipping: {
			title: 'Shipping',
			description: `It usually takes 1-3 weeks to deliver the glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@dresden.vision or 0800 447 111.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
Contact our customer support team at hello@dresden.vision or call 0800 447 111 to start the return process.</br>
Provide your order details and the reason for your return.</br>
Once approved, you'll receive instructions on how to return the item.</br>
	</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@dresden.vision or call 0800 447 111.`,
		},
	},
	ca: {
		shipping: {
			title: 'Shipping',
			description: `It usually takes 10-17 days to deliver the glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@ca.dresden.vision or (647) 424 4288.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are dedicated to ensuring your satisfaction with every purchase. If you're not completely satisfied with your glasses, we offer a simple returns policy to provide you with peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We stand behind the quality of our products. If you’re not fully satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please ensure the item is returned in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
<ul>
<li>Contact our customer support team at hello@ca.dresden.vision or call (647) 424 4288 to start the return process.</li>
<li>Provide your order details and the reason for your return.</li>
<li>Once approved, you will receive instructions on how to return the item.</li>
</ul>
	</br>
</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days of receiving the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you wish to exchange your item for a different colour, style, or size, please specify your preference when initiating the return process. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, please contact us immediately. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For further assistance or questions regarding returns, please contact our customer support team at hello@ca.dresden.vision or call (647) 424 4288.`,
		},
	},
	international: {
		shipping: {
			title: 'Shipping',
			description: `It usually takes 1-3 weeks to deliver the glasses.
After your order has been dispatched, you will receive an email with your tracking number. You can also track your order status on your order page. If you have any questions or if your order hasn't arrived within the expected timeframe, feel free to contact us at hello@int.dresden.vision or +1 (213) 223-6100.
<br>*Please note that during peak times, such as Christmas or sale periods, there may be delays in processing and delivering your order. <br> <br>Please be advised that the destination country may apply import taxes, customs duties, or other fees. These charges will be handled by the customer/recipient. Dresden is not responsible for VAT or Import Taxes on shipments. The customer/recipient will handle any customs duties and extra fees from the destination country.`,
		},
		returns: {
			title: 'Warranty & Returns',
			description: `At Dresden, we are committed to ensuring your satisfaction with every purchase. If you're not completely happy with your glasses, our easy returns policy is designed to give you peace of mind.
	</br>
</br>
<span class="font-medium">30-Day Satisfaction Guarantee</span></br>
We take pride in the quality of our products. If you're not entirely satisfied with your purchase within 30 days of receiving it, you can return it for a full refund or exchange. Please make sure the item is in its original condition with all packaging intact.
	</br>
</br>
<span class="font-medium">How to Initiate a Return or Exchange</span></br>
<ul>
<li>Contact our customer support team at hello@int.dresden.vision or call +1 (213) 223-6100 to start the return process.</li>
<li>Provide your order details and the reason for your return.</li>
<li>Once approved, you'll receive instructions on how to return the item.</li>
</ul>
</br>
<span class="font-medium">Return Shipping</span></br>
Customers are responsible for return shipping costs unless the return is due to a manufacturing defect or an error on our part.
	</br>
</br>
<span class="font-medium">Refunds</span></br>
Refunds will be processed to the original payment method within 5 business days after we receive the returned item.
	</br>
</br>
<span class="font-medium">Exchanges</span></br>
If you'd like to exchange your item for a different colour, style, or size, please let us know when initiating the return. Exchanges are subject to availability.
	</br>
</br>
<span class="font-medium">Damaged or Defective Items</span></br>
If you receive a damaged or defective item, contact us right away. We will arrange a replacement or refund at no additional cost to you, though postage charges may apply.
	</br>
</br>
<span class="font-medium">Contact Us</span></br>
For any further assistance or questions regarding returns, please reach out to our customer support team at hello@int.dresden.vision or call +1 (213) 223-6100.`,
		},
	},
};